import { SafeSpace } from '../types';
import { pipe } from 'fp-ts/function';
import { fromEithersToThese, unsafeRight } from '../io-ts-js';
import { logError, monoidString } from '../utils';
import * as THS from 'fp-ts/These';
import * as O from 'fp-ts/Option';

const getPinned = (space: SafeSpace): readonly string[] => {
    const safeArray = unsafeRight(space.get('pinned'));
    return pipe(
        safeArray.toArray(),
        fromEithersToThese(monoidString),
        THS.mapLeft((errors) => {
            errors.forEach(logError);
            return errors;
        }),
        THS.getRight,
        O.getOrElseW(() => []),
    );
};
export default getPinned;
